import { createContext as s, useContext as n } from "react";
import { MimeTypeValidator as c } from "../Utils/index.js";
const p = s(
  null
), i = {
  selectedItems: [],
  // 已選擇的影片
  setSelectedItems: (e) => {
  },
  // 已選擇的影片 setter
  limit: 1,
  // 能選擇的影片數量
  uploadProps: {}
  // 上傳影片的屬性
}, d = () => {
  var t;
  const e = n(p), o = ((t = e == null ? void 0 : e.uploadProps) == null ? void 0 : t.accept) || void 0, r = new c(o);
  return {
    ...i,
    ...e,
    mime: r
  };
};
export {
  p as MediaLibraryContext,
  d as useProps
};
